export type PassportPermissionTypeSource = {
  objectTypeId?: number | string | null
  inventObjectsTypeId?: number | string | null
}

/**
 * Id для проверки passport_permissions: глобальный object_type_id элемента
 * и (legacy) catalog invent_objects_type_id, если права сохранялись по каталогу.
 */
export function resolvePassportPermissionTypeIds(
  source: PassportPermissionTypeSource,
): number[] {
  const globalId = Number(source.objectTypeId) || 0
  const catalogId = Number(source.inventObjectsTypeId) || 0
  const ids: number[] = []
  if (globalId > 0) ids.push(globalId)
  if (catalogId > 0 && catalogId !== globalId) ids.push(catalogId)
  return ids
}
